/* eslint-disable no-underscore-dangle */
/* eslint-disable prettier/prettier */
/* eslint-disable arrow-body-style */
// material-ui
import { LinearProgress, Typography } from '@mui/material';
import axios from 'axios';
import useTweets from 'hooks/useTweets';
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import TweetsyConfig from 'TweetsyConfig';
import { useTheme } from '@mui/material/styles';
import useAuth from 'hooks/useAuth';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import QueueCard from './QueueCard';
import ThreadCard from './QueueCard/ThreadCard';
import { Box } from '@mui/system';

const Queue = () => {
    const { dbUser, dbLoginUser } = useAuth();
    const { queue, setQueue } = useTweets();
    const theme = useTheme();
    const [triggerQueueFetch, setTriggerQueueFetch] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        axios.get(`${TweetsyConfig.getNodeUrl()}TweetThread/${dbUser._id}`)
            .then(res => {
                console.log('Queue res', res.data)
                setQueue(res.data.shceduledTweets.reverse())

            }).catch(err => {
                console.log('Error form queue page', err)
            }).finally(() => {
                setIsLoading(false)
            })

    }, [triggerQueueFetch])

    return (
        <>
            {isLoading && <LinearProgress sx={{ mt: '-15px', mx: '-10px', mb: 2 }} />}
            <MainCard>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mb: 5
                    }}
                >
                    <Typography variant="h2">Queue</Typography>
                    <Typography><b>Total Tweet count : </b>{dbLoginUser.tweetCount} </Typography>
                </Box>

                {queue.map(tweet => (
                    <>
                        {tweet.texts.length === 1 ? <QueueCard key={tweet._id} id={tweet._id} isSingle tweet={tweet.texts[0]} dateTimeMS={tweet.dateTimeMS} status={tweet.status} setTriggerQueueFetch={setTriggerQueueFetch} />
                            :
                            <ThreadCard key={tweet._id} id={tweet._id} texts={tweet.texts} len={tweet.texts.length} dateTimeMS={tweet.dateTimeMS} status={tweet.status} setTriggerQueueFetch={setTriggerQueueFetch} />
                        }
                    </>
                ))}


                {/* <QueueCard /> */}
                {/* <ThreadCard /> */}
                {/* <QueueCard /> */}


                <ToastContainer position="bottom-right" autoClose={2000} />
            </MainCard >
        </>
    );
};

export default Queue;
